<template>
  <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"> {{ $t('Trial-Balance-of-Expense-Center') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>



            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>


              <v-flex xs12 sm6 md4 style="padding-right:2px;padding-bottom:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Total-Debit-v2') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit-Total') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Current-Payable') }} / {{ $t('Credit') }}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Total-Debit-v2') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit-Total') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Grand-Total') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

               <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">business_center</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                   {{ toplamBakiye | bakiyekontrolsimgeli }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('General-Balance') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>



            </v-layout>
          </v-container>

          <v-container fluid>



            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>
                </v-flex>
                <v-flex xs12 sm6 md2>
                            <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                </v-flex>


                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                     <v-badge color="white"  :overlap="true">
                          <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline      
                              </v-icon>
                          </template>

                          <v-btn small="" @mouseenter="tooltip = true"
                              @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                              color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                          </v-btn>

                           <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>{{$t('Add-Search-Filter')}}</span>
                          </v-tooltip>

                       </v-badge>
                  </v-layout>
                </v-flex>

                <v-dialog v-model="dialogfiltre" persistent="" max-width="410px">
                  <v-card color="grey lighten-2">
                    <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-flex xs12 sm12 md12>
                <v-layout justify-space-between column>
                        <v-select :items="masrafmerkezi" hide-details="" :label="$t('Initial-Cost')" item-text="Title" v-model="MizanMasraf.BaslangicMasraf.Code"
                          clearable item-value="Code" max-height="400"></v-select>
                        <v-select :items="masrafmerkezi" hide-details="" :label="$t('Final-Cost')" item-text="Title" v-model="MizanMasraf.BitisMasraf.Code"
                          clearable item-value="Code" max-height="400" persistent-hint></v-select>
                           <v-checkbox hide-details="" :label="$t('Do-Not-Show-Balances-below-1')" v-model="MizanMasraf.BakiyeBirAltiGosterme "></v-checkbox>

                        <v-checkbox hide-details="" v-model="tumsirketler" :label="$t('All-Companies')"></v-checkbox>
                </v-layout>
                        </v-flex>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{  $t('Apply-Filters') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                   <v-flex xs12 sm12 md12>

                  <v-card>

                    <div class="masraf-merkezi-report-table">
                    <ReportTable
                      :headers="masrafMerkeziReportHeaders"
                      :items="items"
                      storage-key="masrafmerkezi_columns"
                      :loading="progress"
                      :has-searched="items && items.length > 0"
                      :show-search="true"
                      :search-label="$t('Search')"
                      :show-frontend-export="true"
                      :export-title="$t('Trial-Balance-of-Expense-Center')"
                      :export-meta-items="masrafMerkeziExportMetaItems"
                      :export-summary-cards="masrafMerkeziSummaryCards"
                      :rows-per-page-items="[50, 100, 250, 500, 1000]"
                    ></ReportTable>
                  </div>
                  </v-card>

                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
             </v-form>
            </v-card>
          </v-container>

        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../api/auth";
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"

  export default {
    data() {
      return {
        PB:'TRY',
         sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi:false,
        valid:true,
        search: "",
        headers: [{
            text: this.$t('Expense-Center-v2'),
            value: "Code"
          },
          {
            text: this.$t('Cost-Center-Name'),
            value: "CodeName"
          },
          {
            text: this.$t('Current-Payable'),
            value: "CariBorc",
            align:  'right'

          },
          {
            text: this.$t('Current-Receivable'),
            value: "CariAlacak",
            align:  'right'

          },
          {
            text: this.$t('General-Debit'),
            value: "GenelBorc",
            align:  'right'

          },
          {
            text: this.$t('General-Credit'),
            value: "GenelAlacak",
            align:  'right'

          },
          {
            text: this.$t('General-Balance'),
            value: "GenelBakiye",
            align:  'right'

          }
        ],
        MizanMasraf: {

          SirketKodu: '',
          BaslangicMasraf: {
            Code: ''
          },
          BitisMasraf: {
            Code: ''
          },
          BaslangicTarih: '',
          BitisTarih: '',
          Cari: {
            Kod: ''
          },
          BakiyeBirAltiGosterme: false,
          CariAlacak: "",
          CariBorc: "",
          CariKod: "",
          CariUnvan: "",
          GenelAlacak: "",
          GenelBakiye: "",
          GenelBorc: ""
        },
        toplamBakiye: 0,
        toplamCariAlacak: 0,
        toplamCariBorc: 0,
        toplamGenelAlacak: 0,
        toplamGenelBorc: 0,
        toplamRisk: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        tumsirketler: false,
        hesapkodu: [],
        anahesap: [],
        masrafmerkezi: [],
        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        tooltip: false,
        el: null,
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      };
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
      components: {
      tarihcomp,
      yetkidialog,
      ReportTable

    },
    mounted() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
          this.toplamBakiye = 0;
    this.toplamCariAlacak = 0;
    this.toplamCariBorc = 0;
    this.toplamGenelAlacak = 0;
    this.toplamGenelBorc = 0;
    this.toplamRisk = 0;

    this.load = true;
    this.load1 = false;
    this.date = helpers.getDateNow()
    this.date2 = helpers.getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      BaslangicTarih: this.date,
      BitisTarih: this.date2,
      SirketKodu: credentials.SirketKodu
    };

    this.$http
      .post(auth.API_URL + "api/TrialBalance/WithExpenseCenter", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      })
      .then(
        response => {
          this.items = response.body.List;
          this.toplamBakiye = response.body.ToplamBakiye

          this.toplamCariAlacak = response.body.ToplamCariAlacak
          this.toplamCariBorc = response.body.ToplamCariBorc
          this.toplamGenelAlacak = response.body.ToplamGenelAlacak
          this.toplamGenelBorc = response.body.ToplamGenelBorc
          this.toplamRisk = response.body.ToplamRisk

          this.load = false;
          this.load1 = true;
        },
        response => {
          if (response.status === 0) {
            this.text = "Service Unavailable";
            this.snackbar = true;
            this.load = false;
            this.load1 = true;
          } else {
            this.text = "Service Unavailable";
            this.snackbar = true;
            this.load = false;
            this.load1 = true;
          }
        }
      );

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },
       computed: {
masrafMerkeziReportHeaders() {
        return [
          { text: this.$t('Expense-Center-v2'), value: 'Code', visible: true, sortable: true, type: 'text', align: 'left', width: '170px' },
          { text: this.$t('Cost-Center-Name'), value: 'CodeName', visible: true, sortable: true, type: 'text', align: 'left', width: '280px' },
          { text: this.$t('Current-Payable'), value: 'CariBorc', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('Current-Receivable'), value: 'CariAlacak', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('General-Debit'), value: 'GenelBorc', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('General-Credit'), value: 'GenelAlacak', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('General-Balance'), value: 'GenelBakiye', visible: true, sortable: true, type: 'balance', align: 'right', width: '170px' }
        ]
      },

      masrafMerkeziExportMetaItems() {
        return [
          { label: this.$t('Starting-Date'), value: this.date, type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.date2, type: 'date' },
          { label: this.$t('Initial-Cost'), value: this.MizanMasraf && this.MizanMasraf.BaslangicMasraf ? this.MizanMasraf.BaslangicMasraf.Code : '' },
          { label: this.$t('Final-Cost'), value: this.MizanMasraf && this.MizanMasraf.BitisMasraf ? this.MizanMasraf.BitisMasraf.Code : '' },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? 'Evet' : 'Hayır' }
        ]
      },

      masrafMerkeziSummaryCards() {
        return [
          {
            title: this.$t('Current-Payable') + ' / ' + this.$t('Credit'),
            items: [
              { label: this.$t('Total-Debit-v2'), value: this.toplamCariBorc, type: 'money' },
              { label: this.$t('Credit-Total'), value: this.toplamCariAlacak, type: 'money' }
            ]
          },
          {
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('Total-Debit-v2'), value: this.toplamGenelBorc, type: 'money' },
              { label: this.$t('Credit-Total'), value: this.toplamGenelAlacak, type: 'money' }
            ]
          },
          {
            title: this.$t('General-Balance'),
            items: [
              { label: this.$t('General-Balance'), value: this.toplamBakiye, type: 'balance' }
            ]
          }
        ]
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      bakiyekontrolsimgeli: function (m) {
        return helpers.bakiyekontrolsimgeli(m);
      }
    },
    methods: {
    getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }

  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
     if (response.status === 0) {
       this.text = "Service Unavailable";
       this.snackbar = true;
     } else {
       this.text = "Service Unavailable";
       this.snackbar = true;
     }
    })

  }

  function filtrekayit() {
    this.filtrevarmi=true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtrevarmi=false
    this.MizanMasraf.BaslangicMasraf = '',
      this.MizanMasraf.BitisMasraf = '',
      this.tumsirketler = false,
      this.dialogfiltre = false


  }


  function getList() {

      if (this.$refs.formtarih.validate()) {


        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {

          this.toplamBakiye = 0;
          this.toplamCariAlacak = 0;
          this.toplamCariBorc = 0;
          this.toplamGenelAlacak = 0;
          this.toplamGenelBorc = 0;

          this.progress = true
          this.load1 = false;


          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.MizanMasraf.BaslangicTarih = this.date
          this.MizanMasraf.BitisTarih = this.date2

          if (this.tumsirketler === true) {
            this.MizanMasraf.SirketKodu = '0'
          } else {
            this.MizanMasraf.SirketKodu = credentials.SirketKodu
          }

          var params = this.MizanMasraf

          this.$http
            .post(auth.API_URL + "api/TrialBalance/WithExpenseCenter", params, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader()
              }
            })
            .then(
              response => {
                this.items = response.body.List;
                this.toplamBakiye = response.body.ToplamBakiye
                this.toplamCariAlacak = response.body.ToplamCariAlacak
                this.toplamCariBorc = response.body.ToplamCariBorc
                this.toplamGenelAlacak = response.body.ToplamGenelAlacak
                this.toplamGenelBorc = response.body.ToplamGenelBorc

                this.progress = false
                this.load1 = true;
              },
              response => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.progress = false
                  this.load1 = true;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.progress = false
                  this.load1 = true;
                }
              }
            );

        } else {
          this.text1 = this.$t('start-date-cannot-greater-than-end-date')
          this.snackbar = true
        }
      }


  }


  function getListHtml() {

    this.toplamBakiye = 0;
    this.toplamCariAlacak = 0;
    this.toplamCariBorc = 0;
    this.toplamGenelAlacak = 0;
    this.toplamGenelBorc = 0;

    this.progress = true
    this.load1 = false;


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang')
    this.MizanMasraf.BaslangicTarih = this.date
    this.MizanMasraf.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.MizanMasraf.SirketKodu = '0'
    } else {
      this.MizanMasraf.SirketKodu = credentials.SirketKodu
    }

    var params = this.MizanMasraf

    this.$http
      .post(auth.API_URL + "api/TrialBalance/WithExpenseCenterHtmlReport", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {

        if (lang=='en')
          {
            // response.bodyText=response.bodyText.toString().replaceAll(" B"," D");
            // response.bodyText=response.bodyText.toString().replaceAll(" A"," C");
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> MASRAF MERKEZİ MİZANI </title>','<title> COST CENTER TRIAL BALANCE </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MASRAF MERKEZİ MİZANI</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>COST CENTER TRIAL BALANCE</font>")

            
             response.bodyText=bodyhtml;
             
          }
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.bodyText], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('TrialBalanceExpense') + ".html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        } else {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        }
      });
  }

  function getListExcel() {

    this.toplamBakiye = 0;
    this.toplamCariAlacak = 0;
    this.toplamCariBorc = 0;
    this.toplamGenelAlacak = 0;
    this.toplamGenelBorc = 0;

    this.progress = true
    this.load1 = false;


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.MizanMasraf.BaslangicTarih = this.date
    this.MizanMasraf.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.MizanMasraf.SirketKodu = '0'
    } else {
      this.MizanMasraf.SirketKodu = credentials.SirketKodu
    }

    var params = this.MizanMasraf

    this.$http
      .post(auth.API_URL + "api/TrialBalance/WithExpenseCenterExcelReport", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('TrialBalanceExpense') + ".xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        } else {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        }
      });
  }


  function beforeMount() {

  }

</script>
<style scoped>
.masraf-merkezi-report-table { width: 100%; }
.masraf-merkezi-report-table > * { width: 100%; }
</style>